import React from "react";

const Features = () => {
  return (
    <div>
      <h2>Features</h2>
      <hr />
      <ul>
        <li>* Detailed information on Jelly Belly beans</li>
        <li>* Fun facts about Jelly Belly</li>
        <li>* Recipes involving Jelly Belly beans</li>
        <li>* Common Jelly Belly beans combinations</li>
        <li>* Historical milestones related to Jelly Belly</li>
      </ul>
    </div>
  );
};

export default Features;
